import standardAPI from '@/api/standard_items';

const state = {
  tour_types: [],
  tour_types_status: '',
  tour_types_MetaData: {},
  tour_types_page: 1,
  tour_types_perPage: 10,
};

const responseUrl = '/organisation-tours/tour_types';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_tour_types ({ commit }, getOptions) {
    commit('TOUR_TYPES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('TOUR_TYPES_SUCCESS', response);
            commit('TOUR_TYPES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('TOUR_TYPES_READY');
            reject(response);
          } else {
            commit('tour_types_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_tour_type ({ commit, dispatch }, itemData) {
    commit('TOUR_TYPES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('TOUR_TYPES_READY');
          reject(response);
        }
      });
    });
  },
  edit_tour_type ({ commit, dispatch }, itemData) {
    commit('TOUR_TYPES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('TOUR_TYPES_READY');
          reject(response);
        }
      });
    });
  },
  remove_tour_type ({ commit, dispatch }, itemData) {
    commit('TOUR_TYPES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('TOUR_TYPES_READY');
          reject(response);
        }
      });
    });
  },
  reorder_tour_type ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_tour_type_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.tour_types_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.tour_types_perPage = max;
  },
  TOUR_TYPES_READY: (state) => {
    state.tour_types_status = 'ready';
  },
  TOUR_TYPES_REQUEST: (state) => {
    state.tour_types_status = 'loading';
  },
  TOUR_TYPES_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.tour_types_MetaData.meta = response.meta;
      state.tour_types_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.tour_types = response.data.map((category) => {
        category.checked = false; // need for some pages where we can select tour_types
        return category;
      }) || [];
    }
    state.tour_types_status = 'success';
  },
  TOUR_TYPES_ERROR: (state) => {
    state.tour_types_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
